import { PageLoadError } from '@components/page-load-error';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/transfers/withdraw')({
  errorComponent: ({ error }) => (
    <PageLoadError pageName='Withdraw From Max Checking' error={error} />
  ),
  loader: () => {
    //eslint-disable-next-line
    throw redirect({
      href: `${import.meta.env.VITE_BASE_URL}/checking/withdrawals/new`,
    });
  },
});
